<template>
    <table-generic
    class="topups-to-submit-table"
    :headerData="tableHeaderData"
    :tableStyles="tableStyles"
    :tableData="topupsToSubmitListMapping"
    :standAlone="false"
    :hasDetail="false"
    noHoverStyles />
</template>

<script setup>
import TableGeneric from '@/components/generic/table/Generic'

/* Vue */
import { computed } from 'vue'

/* Aux */
import { amountFormat } from '@/assets/scripts/amounts'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props
@topupsToSubmit {Array} - array with cards topups to submit
@isMobile {Boolean}
*/
const props = defineProps({
    topupsToSubmit: Array,
    isMobile: Boolean
})

/*************************************************
*                                                *
*                     Table                      *
*                                                *
*************************************************/
const tableHeaderData = [
    {
        label: t('approvals.pendingSignature.modal.details.topupsToSubmit.tableHeaders.card'),
        rowCellType: 'description',
        dataAttr: 'card',
        showInMobile: { groupWith: ['amount', 'description'] }
    },
    {
        label: t('approvals.pendingSignature.modal.details.topupsToSubmit.tableHeaders.amount'),
        rowCellType: 'description',
        dataAttr: 'amount'
    },
    {
        label: t('approvals.pendingSignature.modal.details.topupsToSubmit.tableHeaders.description'),
        rowCellType: 'description',
        dataAttr: 'description'
    }
]

const tableStyles = [
    { width: '30%' },
    { width: '30%', 'text-align': 'right', 'padding-right': '16px' },
    { width: '40%' }
]

/* Map for table */
const topupsToSubmitListMapping = computed(() => {
    return props.topupsToSubmit.map((topup, index) => ([
        { value: index, dataAttr: 'id' },
        { type: 'title', value: topup.card.cardNumber, dataAttr: 'card' },
        { type: 'description', value: amountFormat(topup.amount, topup.currency), dataAttr: 'amount' },
        {
            type: 'description',
            value: topup.description === '' ? '-' : topup.description,
            dataAttr: 'description'
        }
    ]))
})
</script>

<style lang="scss" scoped>
.topups-to-submit-table {
    :deep(.table-header-cell):first-of-type,
    :deep(.cell-wrapper):first-of-type {
        padding-left: 24px;
    }
}
</style>
